<template>
  <div class="privacy-page">
    <content-page type="privacy" title="隐私政策" />
  </div>
</template>

<script>
import ContentPage from '../components/ContentPage.vue';

export default {
  name: 'PrivacyPage',
  components: {
    ContentPage
  }
}
</script>

<style scoped>
.privacy-page {
  min-height: 100vh;
}
</style> 